import React from 'react'
import './Contact.css';
import SingleEntry from './SingleEntry';

function Contact() {
  return (
    <div className='contact'>
        <h4>Contact</h4>
        <hr></hr>
        <SingleEntry />
    </div>
  )
}

export default Contact